import { connect } from 'react-redux';
import { grantChineseDigitalTranslationCredit } from 'researcher/digital-orders/actions';
import ChineseDigitalTranslationTrial from './ChineseDigitalTranslationTrial';
var mapStateToProps = function mapStateToProps(_ref) {
  var application = _ref.application,
    user = _ref.user;
  return {
    siteLanguage: application.siteLanguage,
    userIdentity: user.identity
  };
};
var mapDispatchToProps = {
  grantChineseDigitalTranslationCredit: grantChineseDigitalTranslationCredit
};
export default connect(mapStateToProps, mapDispatchToProps)(ChineseDigitalTranslationTrial);